// Built apps always check. Dev opts in per developer via
// VITE_APP_ENABLE_VERSION_CHECK_DEV=true in a local .env, so nobody else picks
// up a version poll they did not ask for. The flag has no effect on a build.
export const IS_VERSION_CHECK_ENABLED =
  !import.meta.env.DEV ||
  import.meta.env.VITE_APP_ENABLE_VERSION_CHECK_DEV === 'true';

export const DEFAULT_CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Returning to the tab fires both `focus` and `visibilitychange`, and switching
// apps repeatedly fires them again; collapse those into one check.
export const MIN_EVENT_CHECK_INTERVAL_MS = 30 * 1000;

export const VERSION_URL = '/version.json';
